import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Tab, Tabs, Stack, Typography } from '@mui/material';
import { SaveAlt } from '@mui/icons-material';
import palette from '@theme/palette';
import { useTranslation } from 'react-i18next';
import { Button } from '@shared/ui/Button';
import { downloadDwgFile } from '@shared-app/utils';
import { useFile, useSolution, useValidationUiStore } from '@entities/solution';
import { ResultHeader } from './ResultHeader';
import { Parameters } from './Parameters';
import { BOQTab } from './BOQTab';
import { Representations } from './Representations';
export function Result() {
    const { t } = useTranslation();
    const { id: fileId } = useParams();
    const { data: file } = useFile(fileId);
    const { selectedSolutionId, activeTab, setActiveTab } = useValidationUiStore();
    const { data: solution, isLoading } = useSolution(fileId, selectedSolutionId);
    const handleTabChange = (_, value) => {
        if (value)
            setActiveTab(value);
    };
    return (_jsxs(Box, { width: 'calc(100% - 480px)', bgcolor: palette.grey[100], children: [_jsx(ResultHeader, {}), _jsx(Box, { sx: {
                    borderBottom: `1px solid ${palette.grey[10]}`,
                    borderTop: `1px solid ${palette.grey[10]}`,
                    bgcolor: 'white',
                    px: 2,
                    mt: -2.2
                }, children: _jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [_jsx(Box, { sx: {
                                backgroundColor: palette.common.white,
                                border: `1px solid ${palette.grey[10]}`,
                                margin: '8px 0',
                                display: 'inline-block'
                            }, children: _jsxs(Tabs, { value: activeTab, onChange: handleTabChange, "aria-label": "Result Tabs", sx: {
                                    minHeight: '36px',
                                    backgroundColor: 'transparent',
                                    display: 'inline-flex',
                                    '& .MuiTabs-flexContainer': { gap: '0px' },
                                    '& .MuiTab-root': {
                                        minHeight: '36px',
                                        textTransform: 'none',
                                        fontSize: '13px',
                                        fontWeight: 400,
                                        color: palette.common.black,
                                        padding: '8px 20px',
                                        borderRadius: '0',
                                        backgroundColor: 'transparent',
                                        borderRight: `1px solid ${palette.grey[10]}`,
                                        minWidth: 'auto',
                                        '&:last-child': { borderRight: 'none' }
                                    },
                                    '& .Mui-selected': {
                                        backgroundColor: palette.grey[200],
                                        fontWeight: 500,
                                        color: `${palette.common.black} !important`
                                    },
                                    '& .MuiTabs-indicator': { display: 'none' }
                                }, children: [_jsx(Tab, { value: "PARAMETERS", label: t('PARAMETERS') }), _jsx(Tab, { value: "BOM", label: t('BILL OF QUANTITIES') }), _jsx(Tab, { value: "REPRESENTATIONS", label: t('REPRESENTATIONS') })] }) }), _jsx(Button, { variant: "outlined", startIcon: _jsx(SaveAlt, {}), size: "medium", onClick: e => downloadDwgFile({ dwg_path: file === null || file === void 0 ? void 0 : file.dwg_path, drawing_file_name: file === null || file === void 0 ? void 0 : file.drawing_file_name }, e), children: t('Download File') })] }) }), _jsx(Box, { p: '16px', height: 'calc(100vh - 200px)', overflow: 'auto', children: !selectedSolutionId || (!solution && !isLoading) ? (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", height: "400px", children: _jsx(Typography, { sx: { fontSize: '15px', color: palette.secondary.text }, children: t('Select a solution to view details') }) })) : isLoading ? (_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", height: "400px", children: _jsx(CircularProgress, {}) })) : (_jsxs(_Fragment, { children: [activeTab === 'PARAMETERS' && _jsx(Parameters, {}), activeTab === 'BOM' && _jsx(BOQTab, {}), activeTab === 'REPRESENTATIONS' && _jsx(Representations, {})] })) })] }));
}
